export const GPC = {
  RADIO_YN: "RADIO_YN",
  GOV_NAME: "GOV_NAME",
  LTGOV_NAME: "LTGOV_NAME",
  Y: "Y",
  N: "N",
  M: "M",
  F: "F",

  HOME_WELC: "HOME_WELC",
  HOME_STRT: "HOME_STRT",
  HOME_RIDE: "HOME_RIDE",
  HOME_INFO: "HOME_INFO",
  HOME_ELIG: "HOME_ELIG",
  HOME_DTELG: "HOME_DTELG",

  FMR: "FMR",
  FMR_APPLY: "FMR_APPLY",
  SHOW_UNAVA: "SHOW_UNAVA",
  //HOME PAGE SCREEN
  HME_FOOTER: "HME_FOOTER",
  HME_HERO_C: "HME_HERO_C",
  HME_SEC1: "HME_SEC1",
  // TRANS SEVERICES OVERVIEW SCREEN -TSO_SCREEN-
  TSO_HERO_C: "TSO_HERO_C",
  TSO_CON_SR: "TSO_CON_SR",
  TSO_CON_FR: "TSO_CON_FR",
  TSO_CON_OT: "TSO_CON_OT",
  TSO_CON_S1: "TSO_CON_S1",
  TSO_CON_S2: "TSO_CON_S2",
  TSO_CON_S3: "TSO_CON_S3",
  TSO_FOOTER: "TSO_FOOTER",
  // SHARED RIDE SERVICE SCREEN -SRS_SCREEN-
  SRS_HERO_C: "SRS_HERO_C",
  SRS_CONTEN: "SRS_CONTEN",
  SRS_LEARN: "SRS_LEARN",
  SRS_HEADER: "SRS_HEADER",
  SHARD_RIDE: "SHARD_RIDE",
  SRS_CONTCT: "SRS_CONTCT",
  // FIXED RIDE SERVICE SCREEN -SRS_SCREEN-
  FRS_HERO_C: "FRS_HERO_C",
  FRS_CONTEN: "FRS_CONTEN",
  FRS_LEARN: "FRS_LEARN",
  FRS_HEADER: "FRS_HEADER",
  FRS_C_S2A: "FRS_C_S2A",
  FRS_C_S2B: "FRS_C_S2B",
  FRS_C_S3A: "FRS_C_S3A",
  FRS_C_S3B: "FRS_C_S3B",
  FRS_FAQS: "FRS_FAQS",
  FRS_CNTCT: "FRS_CNTCT",
  // HOW TO SCHEDULE A RIDE SCREEN -HTS_SCREEN-
  HTS_HERO_C: "HTS_HERO_C",
  HTS_CONTEN: "HTS_CONTEN",
  HTS_STEPS: "HTS_STEPS",
  HTS_FOOTER: "HTS_FOOTER",
  HTS_CONTN2: "HTS_CONTN2",
  // HOW TO APPLY SCREEN -HTA_SCREEN-
  HTA_HERO_C: "HTA_HERO_C",
  HTA_CON_1A: "HTA_CON_1A",
  HTA_CON_1B: "HTA_CON_1B",
  HTA_CON_2A: "HTA_CON_2A",
  HTA_CON_2B: "HTA_CON_2B",
  HTA_CON_2C: "HTA_CON_2C",
  HTA_CON_3A: "HTA_CON_3A",
  HTA_NEED_H: "HTA_NEED_H",
  HTA_FOOTER: "HTA_FOOTER",
  // PROGRAMS FOR SENIORS
  TPS_HERO_C: "TPS_HERO_C",
  TPS_CON_1: "TPS_CON_1",
  TPS_CON_2: "TPS_CON_2",
  TPS_CNTCT: "TPS_CNTCT",
  TPS_LEARN: "TPS_LEARN",
  // TRANS PROGRAMS FOR LOW INCOME -TPL_SCREEN-
  TPL_HERO_C: "TPL_HERO_C",
  TPL_CON_1: "TPL_CON_1",
  TPL_CON_2: "TPL_CON_2",
  TPL_LEARN: "TPL_LEARN",
  // TRANS PROGRAM PERSONS WITH DISABILITIES - TPD_SCREEN
  TPD_HERO_C: "TPD_HERO_C",
  TPD_LEARN: "TPD_LEARN",
  TPD_CON_1A: "TPD_CON_1A",
  TPD_CON_1B: "TPD_CON_1B",
  TPD_CON_1C: "TPD_CON_1C",
  TPD_CON_2A: "TPD_CON_2A",
  //CONTACT US
  CNT_US_C: "CNT_US_C",
  // IMAGES
  OLD_65: "OLD_65",
  APP_OVRWV: "APP_OVRWV",
  AUTO_MOBL: "AUTO_MOBL",
  BICYCLE: "BICYCLE",
  CNTCT_US: "CNTCT_US",
  FXD_RT_SRV: "FXD_RT_SRV",
  FXD_RT_TRS: "FXD_RT_TRS",
  HME_ALLOPT: "HME_ALLOPT",
  HME_FXRT: "HME_FXRT",
  HME_MAIN: "HME_MAIN",
  HME_SHRRD: "HME_SHRRD",
  HME_TRANS: "HME_TRANS",
  HOW_APPL: "HOW_APPL",
  LAPTOP: "LAPTOP",
  MONEY: "MONEY",
  LOW_INCOME: "LOW_INCOME",
  PGM_PWD: "PGM_PWD",
  PGM_SSR: "PGM_SSR",
  PG_SRS: "PG_SRS",
  PG_SRW: "PG_SRW",
  TRN_IMG: "TRN_IMG",
  TRN_SRVC: "TRN_SRVC",
  TRNS_PGM: "TRNS_PGM",
  TRS_FRT: "TRS_FRT",
  TRN_SRD: "TRN_SRD",
  WALK: "WALK",
  WHL_CHR: "WHL_CHR",
  IMG_PLAN: "IMG_PLAN",
  IMG_SNR: "IMG_SNR",
  SEL_CNTY: "SEL_CNTY",
  FLT_CNTIES: "FLT_CNTIES",
  OVERVIEW: "OVERVIEW",
  SRS_VIDEO: "SRS_VIDEO",
  FRS_VIDEO: "FRS_VIDEO",
  SRS_TRAING: "SRS_TRAING",
  FRS_TRAING: "FRS_TRAING",
  HME_LEARN: "HME_LEARN",
};

export const GPC_DEFAULT: string[] = [
  GPC.HOME_WELC,
  GPC.HOME_STRT,
  GPC.HOME_RIDE,
  GPC.HOME_INFO,
  GPC.SEL_CNTY,
  GPC.FLT_CNTIES,
];
